"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeletePreset = exports.usePatchPreset = exports.useSharePreset = exports.useGetListUserPreset = exports.useUpdatePreset = exports.useGetPreset = exports.useCreatePreset = exports.useGetListPreset = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectiveAnalyticsClient_1 = require("client/ObjectiveAnalyticsClient");
const objectiveComparativeKeys_1 = __importDefault(require("consts/queryKeys/objectiveComparativeKeys"));
const useGetListPreset = (options) => {
    const fetchGetPreset = () => {
        return (0, ObjectiveAnalyticsClient_1.getListPreset)();
    };
    return (0, react_query_1.useQuery)(objectiveComparativeKeys_1.default.default, () => fetchGetPreset(), options);
};
exports.useGetListPreset = useGetListPreset;
const useCreatePreset = () => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectiveAnalyticsClient_1.createPreset)(body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useCreatePreset = useCreatePreset;
const useGetPreset = (id, options) => {
    const fetchObjectiveComparative = () => {
        return (0, ObjectiveAnalyticsClient_1.getObjectiveComparative)(id);
    };
    return (0, react_query_1.useQuery)(objectiveComparativeKeys_1.default.preset(id, null), () => fetchObjectiveComparative(), options);
};
exports.useGetPreset = useGetPreset;
const useUpdatePreset = (id) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectiveAnalyticsClient_1.updateObjectiveComparative)(id, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useUpdatePreset = useUpdatePreset;
// ** Will Be Used in Next Release **
const useGetListUserPreset = (params, options) => {
    const fetchGetUsers = (olderThan, signal) => {
        return (0, ObjectiveAnalyticsClient_1.getUsersSharingPreset)(Object.assign(Object.assign({}, params), { olderThan }), signal);
    };
    return (0, react_query_1.useInfiniteQuery)(objectiveComparativeKeys_1.default.preset(null, params), ({ pageParam, signal }) => fetchGetUsers(pageParam, signal), Object.assign({ getNextPageParam: lastPage => {
            var _a, _b;
            return (_b = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.olderThan;
        } }, options));
};
exports.useGetListUserPreset = useGetListUserPreset;
// ** Will Be Used in Next Release **
const useSharePreset = (id) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectiveAnalyticsClient_1.shareUsersPreset)(id, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useSharePreset = useSharePreset;
const usePatchPreset = (id) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectiveAnalyticsClient_1.patchPreset)(id, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.usePatchPreset = usePatchPreset;
const useDeletePreset = (id) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, ObjectiveAnalyticsClient_1.deletePreset)(id, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useDeletePreset = useDeletePreset;
